<template>
  <div class="referred" style="width: 100%">
    <v-card-text>
<v-row>
  <v-col cols="12">
    <div class="req-list">
      <div :class="'req-card '+card_style(item)" style="padding: 2px" v-longclick="() => long_click(item)"
           v-on:click="goToDetail(item)"

           v-for="item in request_items"
           :key="item.Id">
        <div>
          <div class="row ">
            <div class="col-6">
              <div
                class="req-name"
                v-text="item.RequestName"
              ></div>
            </div>
            <div class="col-3">
              <div
                class="req-name"
                v-text="item.PFactorTitle"
              ></div>

            </div>
            <div class="col-3">
              <div

                class="req-name"
                v-text="item.CreatedAt"
              ></div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </v-col>
  <v-btn color="primary" style="border-radius: 0px;" class="enter-btn footer_btn"  v-on:click="goToDetail(null)">ثبت فاکتور خرید جدید</v-btn>

</v-row>

    </v-card-text>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  import VueSignaturePad from 'vue-signature-pad'
  Vue.use(VueSignaturePad)

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        doc_type:112,
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_informher_master();
    },

    methods: {
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        var editable = 0;
        var master_id = 0;
        if(item==null){
          editable=1;
          master_id=0;
        }else{
          master_id=item.MasterFactorId
          if(item.DocStatusId==0){
            editable=1;
          }else{
            editable=0;
          }
        }
        this.$router.push({path:'/report-request/informher-items/'+this.$route.params.req_id+'/'+master_id+"/"+this.doc_type+"/"+editable})
      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      get_informher_master () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.req_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetMasterInformHer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_items = response.data.items.filter(x => x.DocType==self.doc_type);
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      undo () {
        this.$refs.signaturePad.clearSignature()
      },
      save () {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png')
        // var data_image = this.$refs.signaturePad.getPropImagesAndCacheImages()
        // console.log(this.$refs.signaturePad.getPropImagesAndCacheImages());
        // console.log(data);
        // Usage example:
        var file = this.dataURLtoFile(data, 'signature.png')
        console.log(file)
        // this.$refs.signaturePad.fromData(data)
        this.upload_image(file)
      },
      upload_image (image_data) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', this.req_type)
        form_data.append('Picture', image_data)

        //
        // const send_data = {
        //   "UserId": user_id,
        // };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            self.send_signature(response.data.ArchiveId, response.data.ImageName)
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type:mime })
      },

      send_signature (archive_id, file_name) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()

        var sign_type = 0

        if (this.req_type == 4) {
          sign_type = 1
        }
        if (this.req_type == 5) {
          sign_type = 2
        }

        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          ImageName: file_name,
          ArchiveId: archive_id,
          SigType: sign_type,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.$router.push({name: 'attachment', params: {'rec_id': self.$route.params.rec_id}})
              if (self.req_type == 4 || self.req_type == 5) {
                self.$router.push({ name: 'requestAddress', params: { rec_id: self.$route.params.rec_id } })
              }
            } else {
              bus.$emit('show_toast', [1500, self.$t('errorUploadSign')])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
